export default __webpack_public_path__ + "static/media/situation-coref-entity-type-unlock.531f6dd2.gif";